import { RouteObject } from 'react-router-dom';
import OverviewPage from '../components/pages/sharedComponents/overview/OverviewPage';
import PaOverview from '../components/pages/performanceAttribution/overview/PAOverview.component';
import AifmdOverviewLegacy from '../components/pages/aifmd/overviewLegacy/AifmdOverviewLegacy.component';
import LiquidityOverview from '../components/pages/liquidity/overview/Overview';
import PaOverviewAlternative from '../components/pages/performanceAttribution/overviewAlternative/PAOverviewAlternative.component';
import SrriShareClassOverview from '../components/pages/ucits/srriShareClassOverview/SrriShareClassOverview';
import EsgOverview from '../components/pages/esg/esgOverview/EsgOverview';
import PeOverview from '../components/pages/privateEquity/peOverview/PeOverview.component';
import CouttsMarketOverview from '../components/pages/manco/couttsMarketOverview/CouttsMarketOverview';
import CoverageRatio from '../components/pages/manco/coverageRatio/CoverageRatio.component';
import Library from '../components/pages/utilities/Library/Library.page';
import Deceased from '../components/pages/ucits/deceased/Deceased';
import NurDeceased from '../components/pages/nurs/deceased/Deceased';
import SifRaifDeceased from '../components/pages/sif-raif/deceased/Deceased.component';
import GlobalExposure from '../components/pages/ucits/globalExposure/GlobalExposure';
import StatusChange from '../components/pages/ucits/statusChange/StatusChange.page';
import AggregateLiquidationPage from '../components/pages/liquidity/aggLiquidation/AggregateLiquidationPage';
import Functionality from '../components/pages/ucits/functionality/Functionality';
import RestrictedCompanies from '../components/pages/utilities/RestrictedCompanies/RestrictedCompanies.component';
import EMIR from '../components/pages/manco/emir/emir.component';
import KPIMonitoring from '../components/pages/utilities/KPIMonitoring/KPIMonitoring.component';
import MancoExposure from '../components/pages/manco/mancoExposure/MancoExposure.component';
import ShareClassHedgeSummary from '../components/pages/sharedComponents/shareClassHedgeSummary/ShareClassHedgeSummary.component';
import ReportDeliveryOversight from '../components/pages/manco/reportDeliveryOversight/ReportDeliveryOversight.component';
import MancoCounterpartyExposure from '../components/pages/manco/mancoCounterpartyExposure/MancoCounterpartyExposure.component';
import PositionOversight from '../components/pages/manco/positionOversight/PositionOversight.component';
import LiquidationTime from '../components/pages/manco/liquidationTime/LiquidationTime.component';
import MancoEquity from '../components/pages/manco/asset_class/equity/MancoEquity';
import MancoFixedIncome from '../components/pages/manco/asset_class/fixed_income/FixedIncome';
import MancoCis from '../components/pages/manco/asset_class/cis/Cis';
import MarketsOverview from '../components/pages/markets/MarketsOverview';
import YieldPage from '../components/pages/yieldCurve/YieldPage';
import ReportGenerator from '../components/pages/performanceAttribution/reportGenerator/ReportGenerator.component';
import FixedIncomeReportGenerator from '../components/pages/utilities/FixedIncomeReprotGenerator/FixedIncomeReportGenerator.component';
import SanctionsScanner from '../components/pages/manco/sanctionsScanner/SanctionsScanner.component';
import AifmdOverview from '../components/pages/aifmd/overview/AifmdOverview.component';
import { OverviewsRoutePaths } from './page-routes';
import ComprehensiveStressTestPage from '../components/pages/stress-tests/ComprehensiveStressTestPage';
import LegacyDashboard from '../components/pages/dashboard/LegacyDashboard';
import { DashboardPage } from '../components/pages/dashboard/DashboardPage';
import AggregationPage from '../components/pages/aggregation/AggregationPage';
import { SimpleGeneralPageWrapper } from '../components/layout/general/SimpleGeneralPageWrapper';
import GeneralRaptorExport from '../components/pages/utilities/RaptorExport/GeneralRaptorExport';
import NavReconOverviewExpandedPage from '../components/pages/navRecon/overview/NavReconOverviewExpandedPage';
import NavReconOverviewPage from '../components/pages/navRecon/overview/NavReconOverviewPage';

// These are all the geneal overview pages routes
export const OverviewsRoutes = (data: any): RouteObject[] => [
  {
    path: OverviewsRoutePaths.OVERVIEW,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'overview'}
        Component={OverviewPage}
        fillAvailableSpace
      />
    ),
  },
  {
    path: OverviewsRoutePaths.PA_OVERVIEW,
    element: (
      <SimpleGeneralPageWrapper pageId={'pa-overview'} Component={PaOverview} />
    ),
  },
  {
    path: OverviewsRoutePaths.AIFMD_OVERVIEW,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'aifmd-overview'}
        Component={AifmdOverview}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.AIFMD_OVERVIEW_LEGACY,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'aifmd-overview-legacy'}
        Component={AifmdOverviewLegacy}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.LIQUIDITY_OVERVIEW,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'liquidity-overview'}
        Component={LiquidityOverview}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.PA_OVERVIEW_ALTERNATIVE,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'pa-overview-alternative'}
        Component={PaOverviewAlternative}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.SRRI_SHARE_CLASS_OVERVIEW,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'srri-share-class-overview'}
        Component={SrriShareClassOverview}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.ESG_OVERVIEW,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'esg-overview'}
        Component={EsgOverview}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.PE_OVERVIEW,
    element: (
      <SimpleGeneralPageWrapper pageId={'pe-overview'} Component={PeOverview} />
    ),
  },
  {
    path: OverviewsRoutePaths.COUTTS_MARKET_OVERVIEW,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'coutts-market-overview'}
        Component={CouttsMarketOverview}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.MANCO_DASHBOARD,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'manco-dashboard'}
        Component={LegacyDashboard}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.DASHBOARD_V2,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'dashboard'}
        Component={DashboardPage}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.AGGREGATION,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'aggregation'}
        Component={AggregationPage}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.COVERAGE_RATIO,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'coverage-ratio'}
        Component={CoverageRatio}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.LIBRARY,
    element: (
      <SimpleGeneralPageWrapper pageId={'library'} Component={Library} />
    ),
  },
  {
    path: OverviewsRoutePaths.DECEASED,
    element: (
      <SimpleGeneralPageWrapper pageId={'deceased'} Component={Deceased} />
    ),
  },
  {
    path: OverviewsRoutePaths.NURS_DECEASED,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'nurs-deceased'}
        Component={NurDeceased}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.SIF_RAIF_DECEASED,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'sif-raif-deceased'}
        Component={SifRaifDeceased}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.GLOBAL_EXPOSURE,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'global-exposure'}
        Component={GlobalExposure}
      />
    ),
  },

  {
    path: OverviewsRoutePaths.STATUS_CHANGE,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'status-change'}
        Component={StatusChange}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.AGGREGATE_LIQUIDATION_TIME,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'aggregate-liquidation-time'}
        Component={AggregateLiquidationPage}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.FUNCTIONALITY,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'functionality'}
        Component={Functionality}
      />
    ),
  },

  {
    path: OverviewsRoutePaths.RESTRICTED_COMPANIES,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'restricted-companies'}
        Component={RestrictedCompanies}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.EMIR,
    element: <SimpleGeneralPageWrapper pageId={'emir'} Component={EMIR} />,
  },

  {
    path: OverviewsRoutePaths.RAPTOR_EXPORTS,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'raptor-exports'}
        Component={GeneralRaptorExport}
      />
    ),
  },

  {
    path: OverviewsRoutePaths.KPI_MONITORING,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'kpi-monitoring'}
        Component={KPIMonitoring}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.MANCO_EXPOSURE,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'manco-exposure'}
        Component={MancoExposure}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.SHARE_CLASS_HEDGE_SUMMARY,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'share-class-hedge-summary'}
        Component={ShareClassHedgeSummary}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.REPORT_DELIVERY_OVERSIGHT,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'report-delivery-oversight'}
        Component={ReportDeliveryOversight}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.MANCO_COUNTERPARTY_EXPOSURE,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'manco-counterparty-exposure'}
        Component={MancoCounterpartyExposure}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.MANCO_POSITION_OVERSIGHT,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'manco-position-oversight'}
        Component={PositionOversight}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.MANCO_LIQUIDATION_TIME,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'manco-liquidation-time'}
        Component={LiquidationTime}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.MANCO_EQUITY,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'manco-equity'}
        Component={MancoEquity}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.MANCO_FIXED_INCOME,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'manco-fixed-income'}
        Component={MancoFixedIncome}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.MANCO_CIS,
    element: (
      <SimpleGeneralPageWrapper pageId={'manco-cis'} Component={MancoCis} />
    ),
  },
  {
    path: OverviewsRoutePaths.MARKETS_OVERVIEW,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'markets-overview'}
        Component={MarketsOverview}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.YIELD_CURVE,
    element: (
      <SimpleGeneralPageWrapper pageId={'yield-curve'} Component={YieldPage} />
    ),
  },
  {
    path: OverviewsRoutePaths.PA_REPORT_GENERATOR,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'pa-report-generator'}
        Component={ReportGenerator}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.FIXED_INCOME_REPORT_GENERATOR,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'fixed-income-report-generator'}
        Component={FixedIncomeReportGenerator}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.SANCTIONS_SCANNER,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'sanctions-scanner'}
        Component={SanctionsScanner}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.COMPREHENSIVE_STRESS_TEST,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'comprehensive-stress-tests'}
        Component={ComprehensiveStressTestPage}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.NAV_RECON_OVERVIEW,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'nav-recon-overview'}
        Component={NavReconOverviewPage}
      />
    ),
  },
  {
    path: OverviewsRoutePaths.NAV_RECON_OVERVIEW_EXPANDED,
    element: (
      <SimpleGeneralPageWrapper
        pageId={'nav-recon-overview-expanded'}
        Component={NavReconOverviewExpandedPage}
      />
    ),
  },
];
